module.exports = __webpack_public_path__ + "img/3-5.97c56600.png";